import * as MyKeysApi from './index';
import * as Orders from '../../../modules/orders';
import { buildCriteraList } from './searchCriteria';
import { setReadRights, resetReadRights } from './devices';
import { GroupCriteriaDto, CustomerInfo } from '../../../models';
import { MyKeysPromise } from './interfaces';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

export const searchPage = (
  pageIdx: number,
  ordersState: Orders.State
): Promise<any> => {
  const requestBatch = ordersState.data.pageSize;

  const criteria = buildCriteraList(ordersState.filters, ordersState.sort);
  const body = {
    groupCriteria: GroupCriteriaDto.OrderNumber,
    criteria,
    pageIndex: pageIdx - 1,
    pageSize: requestBatch,
  };

  Logger.info(
    ['POST: Order Search Requested', ordersState, body],
    LogArea.Api
  );
  return MyKeysApi.post('devices/GetGroupList', body, true)
    .then((res) => MyKeysApi.Map.mapOrderGroupListDto(res.data))
    .catch(MyKeysApi.parseError);
};

export const assingReadRights = (
  customer: CustomerInfo,
  keys: string[]
): MyKeysPromise<boolean> => {
  const criteria = Orders.getCriteria(keys);
  return setReadRights([], [], criteria, customer);
};

export const removeReadRights = (keys: string[]): MyKeysPromise<boolean> => {
  const criteria = Orders.getCriteria(keys);
  return resetReadRights([], [], criteria);
};
